import cookieService from './cookie.service';

class TokenService {
  getRefreshToken(): string | null {
    return cookieService.get('refresh_token');
  }

  getAccessToken(): string | null {
    return cookieService.get('access_token');
  }

  setRefreshToken(refreshToken: string): void {
    cookieService.setAuthToken('refresh_token', refreshToken);
  }

  setAccessToken(accessToken: string): void {
    cookieService.setAuthToken('access_token', accessToken);
  }

  getCurrentCustomerId(): string | null {
    return cookieService.get('selectedCustomerId');
  }
}

export default new TokenService();
